import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M9.088 7A2.086 2.086 0 0 1 7 9.09 2.086 2.086 0 0 1 4.912 7c0-1.155.933-2.088 2.088-2.088S9.088 5.845 9.088 7Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M7 11.824c2.06 0 3.978-1.213 5.314-3.313.525-.823.525-2.205 0-3.028C10.978 3.383 9.06 2.17 7 2.17c-2.06 0-3.978 1.213-5.314 3.313-.525.823-.525 2.205 0 3.028C3.022 10.61 4.94 11.824 7 11.824Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }